// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_it","advertCardNum":"c-a_iu"};